import { motion } from "framer-motion";

export const revealVariants = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1], delay: i * 0.08 },
  }),
};

export default function Reveal({ children, className = "", delay = 0, as = "div" }) {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      variants={revealVariants}
      custom={delay}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.15 }}
    >
      {children}
    </MotionTag>
  );
}

export const CmykDots = ({ className = "" }) => (
  <span className={`inline-flex items-center gap-1.5 ${className}`} aria-hidden="true">
    <span className="cmyk-dot bg-cyanbrand" />
    <span className="cmyk-dot bg-mag" />
    <span className="cmyk-dot bg-yel" />
    <span className="cmyk-dot bg-paper" />
  </span>
);
